export default {
  methods: {
    /**
     * 半形字串轉全形字串 (元壽指定規則)
     * @param {*} e 原始字串資料
     */
    esapiHalfToFull (e) {
      if (!e) {
        return e
      }
      let asciiTable = [ '!', '\\"', '#', '$', '%', '&', '\'', '(', ')',
        '*', '+', ',', '-', '.', '/', '0', '1', '2', '3', '4', '5',
        '6', '7', '8', '9', ':', ';', '<', '=', '>', '?', '@', 'A',
        'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
        'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y',
        'Z', '[', '\\', ']', '^', '_', '`', 'a', 'b', 'c', 'd', 'e',
        'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q',
        'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '{', '|', '}', '~' ]
      let big5Table = [ '！', '”', '＃', '＄', '％', '＆', '’', '（', '）',
        '＊', '＋', '，', '－', '。', '／', '０', '１', '２', '３', '４', '５',
        '６', '７', '８', '９', '：', '；', '＜', '＝', '＞', '？', '＠', 'Ａ',
        'Ｂ', 'Ｃ', 'Ｄ', 'Ｅ', 'Ｆ', 'Ｇ', 'Ｈ', 'Ｉ', 'Ｊ', 'Ｋ', 'Ｌ', 'Ｍ',
        'Ｎ', 'Ｏ', 'Ｐ', 'Ｑ', 'Ｒ', 'Ｓ', 'Ｔ', 'Ｕ', 'Ｖ', 'Ｗ', 'Ｘ', 'Ｙ',
        'Ｚ', '〔', '＼', '〕', '︿', '＿', '‵', 'ａ', 'ｂ', 'ｃ', 'ｄ', 'ｅ',
        'ｆ', 'ｇ', 'ｈ', 'ｉ', 'ｊ', 'ｋ', 'ｌ', 'ｍ', 'ｎ', 'ｏ', 'ｐ', 'ｑ',
        'ｒ', 'ｓ', 'ｔ', 'ｕ', 'ｖ', 'ｗ', 'ｘ', 'ｙ', 'ｚ', '｛', '｜', '｝', '～' ]
      let find = false
      let caStr
      let outStr = []
      var ca = []
      for (var i = 0; i < e.length; i++) {
        ca.push(e.charAt(i))
      }
      for (var a = 0; a < ca.length; a++) {
        caStr = ca[a]
        if (caStr === ' ') {
          caStr = ' '
          find = true
        } else {
          for (var b = 0; b < asciiTable.length; b++) {
            if (caStr === asciiTable[b]) {
              caStr = big5Table[b]
              find = true
              break
            }
          }
        }
        if (find) {
          outStr.push(caStr)
        } else {
          if (caStr.trim() !== '') {
            outStr.push(caStr)
          } else {
            outStr.push(' ')
          }
        }
      }
      var newStr = outStr.join('').trim()
      return newStr
    },
    checkEsapiRule (e, rule) {
      if (!e) {
        return e
      }
      let regex = /^[a-zA-Z0-9.\-\\/\\?\\*+=@#_,:\\[\]{}()\u2502 \u4e00-\u9fa5\uE000-\uF848\u3000-\u3003\u3008-\u300F\u3010-\u3011\u3014-\u3015\u301C-\u301E\uFF01-\uFF5E\u02bc\u2303\u1e5f\u00e9\u0268\u0289]*$/
      let caStr
      let outStr = []
      let newStr
      var ca = []
      if (rule === 'rule2') {
        e = this.esapiHalfToFull(e)
      }else if (rule === 'rule4') {//fix: Issue #99797 , 修正 地址欄位中的 [巷]，僅能輸入數字(包含全形數字)與 常見中文範圍(\u4e00-\u9fa5)
        regex = /^[0-9\uFF10-\uFF19\u4e00-\u9fa5]+$/
        e = this.esapiHalfToFull(e)
      }
      for (var i = 0; i < e.length; i++) {
        ca.push(e.charAt(i))
      }

      if (rule === 'rule1') {
        for (var a = 0; a < ca.length; a++) {
          caStr = ca[a]
          if (regex.test(caStr)) {
            outStr.push(caStr)
          }
        }
        newStr = outStr.join('').trim()
        newStr = this.toUpper(newStr)
      }

      if (rule === 'rule2' || rule === 'rule4') {
        for (var b = 0; b < ca.length; b++) {
          caStr = ca[b]
          if (regex.test(caStr)) {
            outStr.push(caStr)
          }
        }
        newStr = outStr.join('').trim()
      }

      if (rule === 'rule3') {
        for (var c = 0; c < ca.length; c++) {
          caStr = ca[c]
          if (regex.test(caStr)) {
            outStr.push(caStr)
          }
        }
        newStr = outStr.join('').trim()
      }

      return newStr
    },
    toUpper: function (v) {
      if (!v) {
        return v
      }
      let ca = []
      let aboriginal = 'ʼ⌃ṟéɨʉ'
      let reg = /^[a-z]+$/i
      let index = -1
      let str = ''
      for (var i = 0; i < v.length; i++) {
        str = v.charAt(i)
        index = str.indexOf(aboriginal)
        if (index === -1) {
          if (reg.test(str)) {
            str = str.toUpperCase()
          }
        }
        ca.push(str)
      }
      str = ca.join('')
      return str
    }
  }
}
